export default "__VITE_ASSET__CqJUPxfo__"